import { useQuery } from 'react-query';
import { getDietCompare } from '../api/getDietCompare';

const useDietCompare = (dietCode, dietQuality, idealCode, idealQuality, userId) => {
  const result = useQuery(
    'diet_compare_' + dietCode + dietQuality + idealCode + idealQuality + userId,
    () => getDietCompare(dietCode, dietQuality, idealCode, idealQuality, userId),
    {
      refetchOnWindowFocus: false,
    },
  );
  return result;
};

export default useDietCompare;
